import { MuiContainer } from '@/features/shared/material-ui';
import { MAX_RELATED_CONTENT, Theme } from '@/utils/constants';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';
import React from 'react';

const darkTheme = {
  root: {
    '& .MuiSkeleton-wave': {
      backgroundColor: 'rgba(255, 255, 255, 0.13)',
    },
    '& .MuiSkeleton-wave::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.08), transparent)',
    },
  },
};

const lightTheme = {
  root: {},
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      marginTop: '40px',
      marginBottom: '80px',
    },

    container: {
      display: 'grid',
      gap: '48px',
      gridTemplateColumns: 'repeat(1, 1fr)',

      [muiTheme.breakpoints.up('md')]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
    },
  }),
  { name: 'GenBlogDetailSkeleton' },
);

const BlogDetailSkeleton = ({ theme = Theme.light }: any) => {
  const classes = useStyles();

  const rootClassName = clsx(classes.root, `${theme}-theme`);

  return (
    <MuiContainer className={rootClassName}>
      <Skeleton
        animation="wave"
        variant="text"
        height={80}
        width={240}
        style={{ marginBottom: '24px' }}
      />
      <div className={classes.container}>
        {Array.from({ length: MAX_RELATED_CONTENT }).map((_, index) => (
          <section key={index.toString()}>
            <Skeleton
              animation="wave"
              variant="rect"
              height={200}
              style={{ marginBottom: '16px' }}
            />
            <Skeleton animation="wave" variant="text" height={40} />
            <Skeleton animation="wave" variant="text" height={100} />
            <Skeleton
              animation="wave"
              variant="rect"
              height={40}
              width={150}
              style={{ marginTop: '8px' }}
            />
          </section>
        ))}
      </div>
    </MuiContainer>
  );
};

export default BlogDetailSkeleton;
